<template>
  <div>
    <button @click="goBack" class="back-button">
      <span class="back-arrow">&lt;&nbsp;</span>返回
    </button>
    <div class="container">
      <div class="left-column">
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(slide, index) in imgs" :key="index">
            <img :src="slide.imgUrl" :alt="`Slide ${index + 1}`" />
          </swiper-slide>

          <!-- 如果需要分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>

          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
      <div class="right-column">
        <h3>{{ productName }}</h3>
        <p>{{ productDescription }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        productName: 'Product Name', // 产品名称
        productDescription: 'This is a brief description of the product.', // 产品描述
        imgs:[],
        swiperOptions: {
          slidesPerView: 1, // 一次显示一个slide
          loop: true, // 循环模式选项
          pagination: {
            el: '.swiper-pagination', // 分页器元素
            clickable: true, // 允许点击分页器切换slide
          },
          navigation: {
            nextEl: '.swiper-button-next', // 下一个按钮元素
            prevEl: '.swiper-button-prev', // 上一个按钮元素
          },
          autoplay: {
          delay: 10000, // 自动播放间隔
          },
        // 其他配置项...
        },
      }
    },
    props:['productId'],
    mounted() {
      this.getProductImg(this.productId);
    },
    methods: {
      goBack(){
        this.$emit('getBack','back')
      },
      getProductImg(code){
        this.getRequest('/yl/product/imags/'+code).then(resp => {
            if (resp) {
                this.imgs = resp.obj.imgs;
            }
        });
      }
    },
};
</script>

<style scoped>

.container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.left-column {
  flex: 0 0 40%; /* 左边列宽度占比 */
  max-width: 400px; /* 最大宽度限制 */
  border-radius: 5%;
}

.right-column {
  flex: 1; /* 右边列占据剩余空间 */
  padding-left: 20px; /* 左右列之间的间距 */
}

/* 图片样式 */
img {
  width: 100%;
  height: auto;
  display: block;
}
.back-button {
  display: inline-block;
  padding: 10px 20px;
  background-color: #f4f4f4;
  color: #333;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.3s ease;
  margin-bottom: 20px;
}

.back-button:hover {
  background-color: #e0e0e0;
}

</style>